import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	input: {
		display: "none"
	},
	button: {
		minWidth: "auto",
		padding: 0,
		...ColorUtil.getBackgroundAndContrastColor("transparent")
	}
})

export default useStyles
